// TODO add ExtendedDate class and this as method
export function formatDate(date: Date, month: Intl.DateTimeFormatOptions['month'] = 'long') {
    //First parameter: locales - Set as 'undefined' to default to user locale
    return date.toLocaleDateString(undefined, {
        year: 'numeric',
        month,
        day: 'numeric',
    })
}